import { Component, OnInit, Input, HostListener, ElementRef, forwardRef, EventEmitter, Output, Injector } from '@angular/core';
import { NG_VALUE_ACCESSOR, FormControl, NgControl } from '@angular/forms';
import { AbstractValueAccessor } from '../abastract-value-accesor';
import { Router } from '@angular/router';

export interface TurboSelectFooterButton {
  action: string;
  content: string;
  class: string;
}

const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => MbTurboSelectComponent),
  multi: true
};

@Component({
  selector: 'app-mb-turbo-select',
  templateUrl: './mb-turbo-select.component.html',
  styleUrls: ['./mb-turbo-select.component.scss'],
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class MbTurboSelectComponent extends AbstractValueAccessor implements OnInit {

  @Input() title;
  @Input() placeholder;
  @Input() rightItem;
  @Input() wrap: boolean;
  @Input() misfit: boolean;
  @Input() preicon: boolean;
  @Input() lowercase: boolean;
  @Input() remove: boolean;
  @Input() mini: boolean;
  @Input() inputList: Array<any>;
  @Input() inputListId: string;
  @Input() footerButton: TurboSelectFooterButton;
  @Input() disabled: boolean;
  @Output() removeItemEmitter: EventEmitter<any> = new EventEmitter<any>();
  validation: FormControl;
  o: boolean;
  value: any;
  searchValue = '';
  private onTouchedCallback: () => void;

  constructor(private injector: Injector,
              private eRef: ElementRef,
              private router: Router) {
    super();
  }

  ngOnInit() {
    this.validation = this.injector.get(NgControl);
  }

  @HostListener('document:click', ['$event.target'])
  public outsideClick(e) {
    if (!this.eRef.nativeElement.contains(e) && (this.o)) {
      this.o = !this.o;
    }
  }

  public toggle() {
    if (!this.disabled) {
      this.o = !this.o;
      this.searchValue = '';
    }
  }

  public set(selected) {
    this.value = selected;
    this.toggle();
  }
  public footerButtonClicked() {
    eval(this.footerButton.action);
  }

  public search(e) {
    this.searchValue = e.path[0].value;
    if (e.charCode === 13) {
      this.toggle();
      e.preventDefault();
    }
  }

  public removeItem(e, item) {
    this.removeItemEmitter.emit(item);
    e.stopPropagation();
  }

  onBlur() {
    this.onTouchedCallback();
  }

  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  public emitValue(e) {
  }
}
